import React, { useEffect } from 'react';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';

const Blog = () => {
  useEffect(() => {
    document.title = 'NEST | Blog';
  }, []);
  return (
    <div>
      <HeroBanner 
        title="Blog" 
        breadcrumbs={['Blog']}
      />
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-7 heading-section text-center ftco-animate">
              <h2>Blog Coming Soon</h2>
              <p>Check back soon for our latest updates and news.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;


